/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {findNearbySelector, selectedAssetSelector} from '@/store/selectors/tracking-selectors';
import {BreadcrumbsType} from '@/types/sidesheet';
import {getNearByCrumb, initialCrumb} from './utils';

/**
 * @useSelectedAssetFindNearByCrumb
 * React Hook to create a selected assets/device find nearby crumb
 * 
 *  ```typescript
 *   import {useRootCrumb} from '@/routes/tracking/hooks';
 * 
 *   const [nearbyCrumb] = useSelectedAssetFindNearByCrumb();
 *  ```
 */
export const useSelectedAssetFindNearByCrumb = () => {
  const [crumbs, setCrumbs] = useState<BreadcrumbsType>(initialCrumb);
  const findNearby          = useSelector(findNearbySelector);
  const selectedAsset       = useSelector(selectedAssetSelector);

  useEffect(() => {
    if (findNearby.isActive) {
      const findNearbyCrumb = getNearByCrumb(findNearby, selectedAsset !== null);
      setCrumbs(findNearbyCrumb);
    } else {
      setCrumbs(initialCrumb);
    }
  }, [findNearby]);
  return [crumbs];
};
